import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { GAS_METER_ID_LENGTH } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import {
  addAddressError,
  removeAddressError,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import {
  selectActiveAddress,
  selectCurrentAddressErrors,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

const useMeterInput = () => {
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const skipCheck = modulesConfig[country]?.meter?.skipSyntaxCheck ?? false
  const showMeterSerialNumber = modulesConfig[country]?.meter?.meterSerialNumber ?? false
  const { pceNo, meterSerialNumber, isEditable, lastSentDate, t, gasMeterUpdate, isValidPce, canRequestMeterData } =
    useGasMeter({
      type: 'client',
    })
  const activeAddress = useSelector(selectActiveAddress)
  const errors = useSelector(selectCurrentAddressErrors)
  const status = isValidPce ? 'valid' : 'error'
  const searchPceAvailableCountries = ['fr']
  const showPceSearchButton = searchPceAvailableCountries.includes(country)
  const meterIdLabelKey = showMeterSerialNumber
    ? 'subscriptionForm:pce_module.metering_point_id.label'
    : 'subscriptionForm:pce_module.meter_id.label'

  const meterIdOnBlurHandler = value => {
    const newPceNo = value?.replace(/ /g, '') ?? ''
    const currentPceNo = pceNo ?? ''

    // No-op blur: skip dispatch when the value hasn't changed (would otherwise
    // reset consent fields AND flip the global save dirty flag for nothing).
    if (newPceNo === currentPceNo) {
      return
    }

    gasMeterUpdate({
      pceNo: newPceNo,
      meterConsent: false,
      consentDate: null,
    })

    if (!newPceNo || (!skipCheck && newPceNo.length !== GAS_METER_ID_LENGTH[country])) {
      setIsValidPce(false)
      return
    }

    dispatch({
      type: subscriptionFormActionsV2.METER_MODULE_VALIDATE_PCE_METER_SYNTAX_V2,
      meterId: newPceNo,
      callback: setIsValidPce,
    })
  }

  const setIsValidPce = value => {
    gasMeterUpdate({ isValidPce: value })
    if (value === false && pceNo?.length > 0) {
      dispatch(
        addAddressError({
          data: { meter_id_gas: [t('subscriptionForm:pce_module.error_validation.pce_syntax')] },
          id: activeAddress,
        }),
      )
      return
    }

    dispatch(removeAddressError({ id: activeAddress, key: 'meter_id_gas' }))
  }

  const meterSerialOnBlurHandler = value => {
    const newMeterSerialNumber = value?.replace(/ /g, '') ?? ''
    const currentMeterSerialNumber = meterSerialNumber ?? ''

    if (newMeterSerialNumber === currentMeterSerialNumber) {
      return
    }

    gasMeterUpdate({ meterSerialNumber: newMeterSerialNumber })
  }

  return {
    meterIdOnBlurHandler,
    meterSerialOnBlurHandler,
    pceNo,
    meterSerialNumber,
    showMeterSerialNumber,
    isEditable,
    errors,
    lastSentDate,
    canRequestMeterData,
    meterStatus: pceNo ? status : null,
    showPceSearchButton,
    meterIdLabelKey,
    t,
  }
}

export default useMeterInput
